import * as Sentry from "@sentry/browser";
import {Integrations} from "@sentry/tracing";

if (process.env.MIX_APP_ENV !== 'local') {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
        environment: process.env.MIX_SENTRY_ENVIRONMENT,

        // Alternatively, use `process.env.npm_package_version` for a dynamic release version
        // if your build tool supports it.
        //release: "my-project-name@2.3.12",
        integrations: [new Integrations.BrowserTracing()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        ignoreErrors: [
            'Non-Error exception captured',
            'Non-Error promise rejection captured'
        ]
    });
}

